import React, { useState } from 'react';
import IndicatorTag from '../cards/IndicatorTag';

const IndicatorTabs = ({ indicators, currentIndicator, onSelect }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const statusLegend = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.75rem', fontWeight: '600' }}>
        <div style={{ width: '16px', height: '16px', borderRadius: '4px', background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)', border: '2px solid #27ae60', flexShrink: 0 }} />
        <span style={{ color: '#27ae60' }}>Normal</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.75rem', fontWeight: '600' }}>
        <div style={{ width: '16px', height: '16px', borderRadius: '4px', background: 'linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)', border: '2px solid #f39c12', flexShrink: 0 }} />
        <span style={{ color: '#f39c12' }}>Warning</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.75rem', fontWeight: '600' }}>
        <div style={{ width: '16px', height: '16px', borderRadius: '4px', background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)', border: '2px solid #c0392b', flexShrink: 0 }} />
        <span style={{ color: '#c0392b' }}>High</span>
      </div>
    </div>
  );

  return (
    <div className="indicator-tabs-container">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '0.5rem',
          cursor: 'pointer',
          userSelect: 'none',
          marginBottom: isExpanded ? '0.5rem' : '0'
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4 style={{ margin: 0 }}>Indicators</h4>
        {isExpanded && statusLegend}
        <span style={{
          fontSize: '0.7rem',
          color: 'var(--primary)',
          transition: 'transform 0.3s ease',
          transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
          display: 'inline-block',
          marginLeft: 'auto'
        }}>
          ▶
        </span>
      </div>
      {isExpanded && (
        <>
          {/* Indicator Tabs */}
          <div className="indicator-tabs" style={{ animation: 'slideDown 0.3s ease-out' }}>
            {indicators.map((item, index) => {
              const { indicator, sector, hasData, status } = item;
              const isActive = indicator.name === currentIndicator;

              const handleClick = () => {
                if (hasData) {
                  onSelect(
                    indicator.name,
                    sector,
                    indicator.threshold,
                    indicator.dataNeeded,
                    hasData
                  );
                }
              };

              return (
                <IndicatorTag
                  key={`${indicator.name}-${index}`}
                  indicator={{
                    name: indicator.name,
                    hasData: hasData,
                    status: status
                  }}
                  onClick={handleClick}
                  isActive={isActive}
                />
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default IndicatorTabs;

